import { CSP_NONCE, CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { BrowserModule, provideClientHydration } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { HomeComponent } from './views/layout/home/home.component';
import { LoginComponent } from './components/login/login.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule, DatePipe, DecimalPipe, KeyValuePipe, SlicePipe } from '@angular/common';
import { LoginService } from './components/login/service/login.service';
import { provideHttpClient, withInterceptors, withJsonpSupport } from '@angular/common/http';
import { NotifierModule, NotifierOptions } from 'angular-notifier';
import { SignUpComponent } from './components/sign-up/sign-up.component';
import { NgLabelTemplateDirective, NgOptionTemplateDirective, NgSelectComponent, NgSelectModule } from '@ng-select/ng-select';
import { VerifyComponent } from './components/verify/verify.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { MainComponent } from './views/layout/main/main.component';
import { HeaderComponent } from './components/header/header.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { authuserInterceptor } from './intercep/authuser.interceptor';
import { TagInputModule } from 'ngx-chips';
import {TooltipModule} from 'ng2-tooltip-directive';
import { RouterModule } from '@angular/router';
import { UnauthorizedComponent } from './views/layout/unauthorized/unauthorized.component';
import { PermissionService } from './permission.service';

import { ReadMoreDirective } from './directives/read-more.directive';
import { SearchPipe } from './pipe/search.pipe';
import { BrowserAnimationsModule, provideAnimations } from '@angular/platform-browser/animations';
import { NoWhitespaceDirective } from './directives/no-whitespace.directive';
 
 
import { NewUserComponent } from './views/layout/post-call/new-user/new-user.component';
import { AudioRecordsComponent } from './views/layout/post-call/audio-records/audio-records.component';
import { HighlightDirective } from './pipe/search-text-highlight/highlight.directive';
import { MinuteSecondsPipePipe } from './pipe/minute-seconds-pipe.pipe';
import { HighlightwordDirective } from './directives/highlightword.directive';
import {NgxPaginationModule} from 'ngx-pagination';



import {  NgxStripeModule } from 'ngx-stripe';
import { provideCharts, withDefaultRegisterables} from 'ng2-charts';
import { SurveyRecordsComponent } from './views/layout/survey-records/survey-records.component';
import { SurveyService } from './views/layout/survey-records/service/survey.service';
import { TextRecordsComponent } from './views/layout/text-records/text-records.component';
import { TextRecordService } from './views/layout/text-records/service/text-record.service';
import { PdfService } from './views/layout/text-records/pdf-service/pdf.service';
import { SurveyFeedbackComponent } from './views/layout/survey-feedback/survey-feedback.component';
import { SurveyfeedbackService } from './views/layout/survey-feedback/service/surveyfeedback.service';
import { AIAssistComponent } from './views/layout/aiassist/aiassist.component';
import { AutocompleteComponent } from './views/layout/aiassist/autocomplete/autocomplete.component';
import { BotComponent } from './views/layout/aiassist/bot/bot.component';
import { AssistBotService } from './views/layout/aiassist/assist-bot.service';
 
 
import { SettingsComponent } from './views/layout/settings/settings.component';
import { SettingsService } from './views/layout/settings/service/settings.service';
import { PageNotFoundComponent } from './views/layout/page-not-found/page-not-found.component';

import { DashboardComponent } from './views/layout/dashboard/dashboard.component';
import { MainService } from './views/layout/main/service/mainservice';
import {NgxDocViewerModule} from 'ngx-doc-viewer';


import { PasswordMaskDirective } from './directives/password-mask.directive';
import { IvrRecordsComponent } from './views/layout/ivr-records/ivr-records.component';

import { IvrService } from './views/layout/ivr-records/service/ivr.service';
import { VoiceMailComponent } from './views/layout/voice-mail/voice-mail.component';
import { VoicemailService } from './views/layout/voice-mail/service/voicemail.service';
import {  BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { EmailFileuploadComponent } from './views/layout/email/email-fileupload/email-fileupload.component';
import { EmailfileuploadService } from './views/layout/email/email-fileupload/service/emailfileupload.service';
import { ArraytostringPipe } from './pipe/arraytostring.pipe';
import { ArrayformationPipe } from './pipe/arrayformation.pipe';
import { TextFileuploadComponent } from './views/layout/text-fileupload/text-fileupload.component';
import { ReadMoreExpandDirective } from './directives/read-more-expand.directive';
import { ToggleDirective } from './directives/toggle.directive';
import { LlmRunComponent } from './views/layout/llm-run/llm-run.component';
import { LlmRunService } from './views/layout/llm-run/service/llmrun.service';
import { VoiceMailuploadComponent } from './views/layout/voice-mailupload/voice-mailupload.component';
import { SelectDropdownComponent, SelectDropdownDirective } from './formcomponents/select-dropdown/select-dropdown.component';
import { DocUploadComponent } from './views/layout/document/doc-upload/doc-upload.component';
import { ButtonModule } from 'primeng/button';
import { SelectModule } from 'primeng/select';
import { VoiceMailConfigurationComponent } from './views/layout/voice-mail-configuration/voice-mail-configuration.component';
import { VoiceMailConfigService } from './views/layout/voice-mail-configuration/service/voice-mail-config.service';
import { DocRecordsComponent } from './views/layout/document/doc-records/doc-records.component';
import { DocrecordsService } from './views/layout/document/doc-records/docrecords.service';
import { ReplaceLineBreaksPipe } from './pipe/replace-line-breaks.pipe';

import { ContractsModule } from './views/layout/contracts/contracts.module';
import { SharedModule } from './modules/shared/shared.module';
import { PostCallModule } from './views/layout/post-call/post-call.module';
import Aura from '@primeng/themes/aura';
import { providePrimeNG } from 'primeng/config';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { DialogService } from './services/dialog.service';
import { InfiniteScrollDirective, InfiniteScrollModule } from 'ngx-infinite-scroll';
import { TrimTextDirective } from './directives/trim-text.directive';
import { PhoneNumberInputComponent } from './components/phone-number-input/phone-number-input.component';
import { DocEditorViewerComponent } from './components/doc-editor-viewer/doc-editor-viewer.component';
import { EmailAuditModule } from './views/layout/email-audit/email-audit.module';
import { AutoLoginComponent } from './components/auto-login/auto-login.component';
 
 
 

 
const customNotifierOptions: NotifierOptions = {
  position: {
    horizontal: {
      position: 'right',
      distance: 50,
    },
    vertical: {
      position: 'top',
      distance: 50,
      gap: 10,
    },
  },
  theme: 'material',
  behaviour: {
    autoHide: false,
    onClick: 'hide',
    onMouseover: 'pauseAutoHide',
    showDismissButton: true,
    stacking: 4,
  },
  animations: {
    enabled: true,
    show: {
      preset: 'slide',
      speed: 100,
      easing: 'ease',
    },
    hide: {
      preset: 'fade',
      speed: 100,
      easing: 'ease',
      offset: 50,
    },
    shift: {
      speed: 100,
      easing: 'ease',
    },
    overlap: 150,
  },
};

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    HomeComponent,
    SignUpComponent,
    VerifyComponent,
    ForgotPasswordComponent,
    MainComponent,
    HeaderComponent,
    SidebarComponent,
    UnauthorizedComponent,
  
   
 
 
     
     SurveyRecordsComponent,
     TextRecordsComponent,
     SurveyFeedbackComponent,
     AIAssistComponent,
     AutocompleteComponent,
     BotComponent,
 
     SettingsComponent,
     PageNotFoundComponent,
  
     DashboardComponent,
  


     IvrRecordsComponent,
     VoiceMailComponent,

  
     TextFileuploadComponent,
  
    LlmRunComponent,
    VoiceMailuploadComponent,

 

   
    VoiceMailConfigurationComponent,
   
    ConfirmDialogComponent,
    AutoLoginComponent,
  
    
     
  
  ],
  imports: [
    PhoneNumberInputComponent,
    DocEditorViewerComponent,
    BrowserModule,
    CommonModule,

    AppRoutingModule,
    RouterModule,
   FormsModule,ReactiveFormsModule,
    SharedModule,
  InfiniteScrollDirective,
    ContractsModule,
    EmailAuditModule,
    NotifierModule.withConfig(customNotifierOptions),
   PostCallModule,
       BsDatepickerModule.forRoot(),
    ButtonModule,
 
    BrowserAnimationsModule,
  InfiniteScrollModule,
 // NgxStripeModule.forChild(),
    NgxStripeModule.forRoot("pk_test_51BTUDGJAJfZb9HEBwDg86TN1KNprHjkfipXmEDMb0gSCassK5T3ZfxsAbcgKVmAIXF7oZ6ItlZZbXO6idTHE67IM007EwQ4uN3"),
  ],
  
  providers: [
    provideClientHydration(),
    provideHttpClient(withJsonpSupport(),withInterceptors([authuserInterceptor])),
    provideAnimations(),
    provideAnimationsAsync(),
    //provideNgxStripe(),
      providePrimeNG({
        theme: { preset: Aura,
          options: {
            darkModeSelector: false // or 'none'
        } },
        
      }),
    PermissionService,
    LoginService,
 
    DatePipe,
    DecimalPipe,
    SlicePipe,
    KeyValuePipe,
 
    SurveyService,
    TextRecordService,
    SurveyfeedbackService,
    PdfService,
    AssistBotService,
 
    SettingsService,
    MainService,

    IvrService,
    VoicemailService,
    
    LlmRunService,
    VoiceMailConfigService,
    DocrecordsService,
    DialogService,
   //provideNgxStripe(),
   
    //provideNgxStripe("pk_test_51BTUDGJAJfZb9HEBwDg86TN1KNprHjkfipXmEDMb0gSCassK5T3ZfxsAbcgKVmAIXF7oZ6ItlZZbXO6idTHE67IM007EwQ4uN3"),
    provideCharts(withDefaultRegisterables())
    ],
  schemas:[CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent]
})
export class AppModule { }
